<template>
  <div v-if="!markerConfig.hide" class="availability-marker" :class="{ 'availability-marker--filtered': filtered }" :style="styles">
    <div v-if="pulse" class="availability-marker__ring" :style="{ animationDelay: animationDelay + 'ms' }"></div>
    <div v-if="status && status !== 'Unassigned'" class="availability-marker__dot">
      <fa v-if="markerIcon" class="availability-marker__icon" :icon="markerIcon"></fa>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { camelCase } from "lodash";
export default {
  props: {
    animationDelay: Number,
    filtered: Boolean,
    x: Number,
    y: Number,
    status: String,
    meta: Object,
    inline: Boolean,
    isDisplayHome: Boolean,
    productType: String,
    specialCondition: String,
    hide: Boolean,
  },
  computed: {
    ...mapGetters({
      config: "newConfig",
    }),

    markerConfig() {
      if (this.isDisplayHome) return this.config.markers.displayHome;
      if (this.status === "Available" && this.specialCondition && this.config.markers[camelCase(this.specialCondition)]) return this.config.markers[camelCase(this.specialCondition)];
      if (this.config.markers[camelCase(this.status)]) return this.config.markers[camelCase(this.status)];
      return this.config.markers.notReleased;
    },

    markerIcon() {
      if (this.productType && this.config.markerIcons[camelCase(this.productType)]) return this.config.markerIcons[camelCase(this.productType)];
      return this.markerConfig.icon;
    },

    pulse() {
      if (this.filtered) return false;
      return this.markerConfig.pulse;
    },

    styles() {
      return {
        position: this.inline ? "relative" : "absolute",
        "--marker-color": this.markerConfig.color,
        left: this.x / 20 + "rem",
        top: this.y / 20 + "rem",
      };
    },
  },
};
</script>

<style lang="scss">
.availability-marker {
  padding: 2rem;
  pointer-events: all;
  transform: translate(-1rem, -1rem);
  z-index: var(--tag-z-index);

  .availability-marker__dot {
    background-color: var(--marker-color);
    color: #fff;
  }

  .availability-marker__icon {
    display: block;
    width: 60%;
  }

  &--filtered {
    pointer-events: none !important;

    .availability-marker__count,
    .availability-marker__dot {
      filter: grayscale(100%);
      opacity: 0.5;
    }
  }

  &__dot {
    border-radius: 50%;
    border: 0.2rem solid white;
    box-shadow: -0.2rem 0.3rem 0.3rem rgba(0, 0, 0, 0.35);
    height: 2rem;
    // transition: all 0.3s;
    width: 2rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    svg {
      display: none;
      font-size: 1.2em;
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  &__ring {
    border: 0.3rem solid #fff;
    border-radius: 3rem;
    height: 2rem;
    width: 2rem;
    position: absolute;
    animation: pulsate 2s ease-out;
    animation-iteration-count: infinite;
    opacity: 0;
  }
}
</style>
